// CSV download helpers, shared by the event dialogs that offer a file in the same
// columns their upload recognises (participants, locations) so a downloaded list
// can be re-uploaded as-is — to another event, or after editing in a spreadsheet.

import { downloadBlob } from "./download";

// Quote a field when it contains a delimiter, quote or line break (doubling any
// embedded quote), so values like a "lat, long" pair survive a round trip.
const csvCell = (v) => {
  const s = v == null ? "" : String(v);
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

// Build a CSV (header row plus any data rows) and trigger a download.
export const downloadCsv = (headers, rows, filename) => {
  const csv = [headers, ...rows].map(r => r.map(csvCell).join(",")).join("\r\n") + "\r\n";
  downloadBlob(new Blob([csv], { type: "text/csv;charset=utf-8;" }), filename);
};

// A CSV containing just the header row, as a starting template.
export const downloadCsvTemplate = (headers, filename) => downloadCsv(headers, [], filename);

// "SDW2026-locations-2026-07-28.csv" — identifies the event it came from.
export const csvFilename = (event, what) => {
  const label = event?.label_short || event?.abbreviation || event?.name || "event";
  const d = new Date();
  const today = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  return `${label.replace(/[^\w.-]+/g, "_").replace(/^_+|_+$/g, "") || "event"}-${what}-${today}.csv`;
};
